export const locale = {
    GENERAL: {
        Navigation:'Navigation',
        Home:'Home',
        Home2:'Home2',
        Standard:'Standard',
        Student: 'Student',
        Case: 'Case',
        EditProfile:'Edit Profile',
        Inbox:'Inbox',
        Calendar:'Calendar',
        Setting:'Setting',
        LogOut:'Log Out',
        test: 'test',
        SearchMenu:'Search Menu',
        Notifications:'Notifications',
        NoRecordFound:'No record found',
        SeeAll:'See all',
        Login: 'Login',
    },
    STUDENT: {
        Student: 'Student',
        StudentNo: 'Student No',
        LastName: 'LastName',
        Gender: 'Gender',
        CenterName: 'CenterName',
        Phone: 'Phone(Home)',
        Mobile: 'Mobile',
        Center: 'Center',
        Telephone: 'Telephone',
        Age: 'age',
    },
    HOME: {
        name: 'name',
        name2: 'name2',
        gender: 'gender',
        center: 'center',
        selectTwo: 'selectTwo',
        email: 'email',
        birthday: 'birthday',
        locale: 'en',
        Male: 'Male',
        Female: 'Female',
        Submit: 'Submit',
        Form: 'Form',
    },
    ASelect: {
        name: 'name',
        select: 'Select an item',
    },

    FullName: 'Full Name',
    Color: 'Color',
    Student: 'Student',
    StudentNo: 'Student No',
    LastName: 'LastName',
    Gender: 'Gender',
    CenterName: 'CenterName',
    Phone: 'Phone(Home)',
    Mobile: 'Mobile',
    Center: 'Center',
    Telephone: 'Telephone',
    Age: 'Age',
    Name: 'Name',
    Male: 'Male',
    Female: 'Female',
    Birthday: 'Birthday',
    Email: 'Email',

    Save: 'Save',
    Search: 'Search',
    Reset: 'Reset',
    Select: 'Select',
    Add: 'Add',
    Remove: 'Remove',
    AddStudent: 'AddStudent',
    Import: 'Import',
    Delete: 'Delete',
    Cancel: 'Cancel',
    AdvanceSearch: 'Advance Search',
    RemoveStudent: 'RemoveStudent',
    SelectCurrent: 'Select current records',
    SelectAll: 'Select all records',

    Delete2: 'Are you sure delete ?',
}
